<button (click)="makePayment(15)" class="btn btn-danger btn-block">Pay $15</button>